import Hero from "../components/layout/Hero";
import { useTranslation } from "../hooks/useTranslation";
import heroImg from "../assets/images/trainers/hero.jpg";
import "../assets/styles/trainers.css";
import TrainersGallery from "../components/trainers/TrainersGallery";

export default function Trainers(props) {
    const t = useTranslation();

    return (
        <section id="trainers-section">
            <Hero title={t("trainers.title")} bgImage={heroImg} />
            <TrainersGallery />
        </section>
    );
}